<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/personList' }">人员</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="insert">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="update">编辑</el-button>
                    <!-- <el-button size="small" plain @click="del">删除</el-button> -->
                    <draggableDetail :draggable="{ data_name: 'person' }" @isErrshow="reload"></draggableDetail>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item
                                        :label="item.title ? item.title + '：' : ''"
                                        v-if="item.prop == 'picture' && data[item.prop]"
                                    >
                                        <div class="read_only read_only_link">
                                            <el-image
                                                :src="data[item.prop]"
                                                :preview-src-list="[data[item.prop]]"
                                                style="width: 80px; height: 112px"
                                            >
                                                <div slot="error" class="image-slot"></div>
                                            </el-image>
                                        </div>
                                    </el-form-item>

                                    <el-form-item :label="item.title ? item.title + '：' : ''" v-else>
                                        <div
                                            class="read_only read_only_link"
                                            v-if="
                                                in_array(item.prop, [
                                                    'main_hierarchy_name',
                                                    'main_hierarchy_principal_name',
                                                    'main_hierarchy_department_name'
                                                ])
                                            "
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="任职记录" name="2">
                    <vHierarchyPersonList v-if="flag" :postList="hierarchy_person_params"></vHierarchyPersonList>
                </el-collapse-item>
                <el-collapse-item disabled title="银行账户" name="3">
                    <vBankAccountComponent v-if="flag3" :postList="postList3"></vBankAccountComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="合同" name="4">
                    <vPersonContractComponent v-if="flag4" :postList="postList4"></vPersonContractComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="经历" name="5">
                    <vPersonExperienceComponent v-if="flag5" :postList="postList5"></vPersonExperienceComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import vHierarchyPersonList from '../../listComponent/jurisdiction/hierarchyPersonListComponent.vue';
import vBankAccountComponent from '../../listComponent/basicdata/bankAccount/bankAccountComponent.vue';
import vPersonContractComponent from '../../listComponent/basicdata/personContract/personContractComponent.vue';
import vPersonExperienceComponent from '../../listComponent/basicdata/personExperience/personExperienceComponent.vue';
import draggableDetail from '../../../common/DrawerDetail.vue';
export default {
    inject: ['reload'],
    name: 'personDetail',
    components: {
        vHierarchyPersonList,
        vBankAccountComponent,
        vPersonContractComponent,
        vPersonExperienceComponent,
        draggableDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2', '3', '4', '5'],
            data: {},
            queryParams: {},
            headerTitle: '人员详情',
            flag: false,
            hierarchy_person_params: {},
            flag3: false,
            postList3: {},
            flag4: false,
            postList4: {},
            flag5: false,
            postList5: {}
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.initSubListParams();
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
            this.flag3 = true;
            this.flag4 = true;
            this.flag5 = true;
        });
    },
    methods: {
        in_array,
        initSubListParams() {
            this.hierarchy_person_params.params = {
                person_rid: this.queryParams.rid,
                order_by: { start_date: 'desc' }
            };
            this.hierarchy_person_params.headerTitle = false;
            this.hierarchy_person_params.code = true;
            this.hierarchy_person_params.status = true;
            this.hierarchy_person_params.hierarchy_rid = true;
            this.hierarchy_person_params.concentration = true;
            this.hierarchy_person_params.start_date_range = true;
            this.hierarchy_person_params.addBtn = true;
            this.hierarchy_person_params.searchBtn = true;
            this.hierarchy_person_params.resetBtn = true;
            this.hierarchy_person_params.downFileBtn = true;
            this.hierarchy_person_params.setBtn = true;

            this.postList3.params = {
                rel_type: 'person',
                rel_rid: this.queryParams.rid
            };
            this.postList3.headerTitle = false;
            this.postList3.addBtn = true;
            this.postList3.searchBtn = true;
            this.postList3.resetBtn = true;
            this.postList3.downFileBtn = true;
            this.postList3.setBtn = true;
            this.postList3.rid = true;
            this.postList3.account_name = true;

            this.postList4.params = {
                person_rid: this.queryParams.rid,
                order_by: { start_date: 'desc' }
            };
            this.postList4.headerTitle = false;
            this.postList4.code = true;
            this.postList4.date = true;
            this.postList4.type = true;
            this.postList4.labour_contract_entity_rid = true;
            this.postList4.person_rid = false;
            this.postList4.employment_form = true;
            this.postList4.status = true;
            this.postList4.is_competition_agreement = true;
            this.postList4.searchBtn = true;
            this.postList4.resetBtn = true;
            this.postList4.downFileBtn = true;
            this.postList4.setBtn = true;
            this.postList4.addBtn = true;

            this.postList5.params = {
                person_rid: this.queryParams.rid,
                order_by: { start_date: 'desc' }
            };
            this.postList5.headerTitle = false;
            this.postList5.code = true;
            this.postList5.person_rid = false;
            this.postList5.classification = true;
            this.postList5.type = true;
            this.postList5.educational = true;
            this.postList5.entity = true;
            this.postList5.date = true;
            this.postList5.searchBtn = true;
            this.postList5.resetBtn = true;
            this.postList5.downFileBtn = true;
            this.postList5.setBtn = true;
            this.postList5.addBtn = true;
        },
        toDetail(prop) {
            if (prop == 'main_hierarchy_name' && this.data.main_hierarchy_rid) {
                this.$router.push({
                    path: '/hierarchyDetail',
                    query: {
                        id: this.data.main_hierarchy_rid
                    }
                });
            } else if (prop == 'main_hierarchy_principal_name' && this.data.main_hierarchy_principal_rid) {
                this.$router.push({
                    path: '/personDetail',
                    query: {
                        id: this.data.main_hierarchy_principal_rid
                    }
                });
            } else if (prop == 'main_hierarchy_department_name' && this.data.main_hierarchy_department_rid) {
                this.$router.push({
                    path: '/departmentDetails',
                    query: {
                        id: this.data.main_hierarchy_department_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).person;
            processColumnDataToRowNew(colData, this);
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'personDelete', this.data.name, 'personList');
        },
        //编辑
        update() {
            this.$router.push({
                path: 'personEdit',
                query: {
                    type: 'update',
                    id: this.data.rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'personEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'personEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid
                }
            });
        },
        //详情
        getData() {
            this.$api
                .personDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.code;
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>